<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-building-skyscraper"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 21l18 0"></path>
    <path d="M5 21v-14l8 -4v18"></path>
    <path d="M19 21v-10l-6 -4"></path>
    <path d="M9 9l0 .01"></path>
    <path d="M9 12l0 .01"></path>
    <path d="M9 15l0 .01"></path>
    <path d="M9 18l0 .01"></path>
  </svg>
</template>
<script lang="ts" setup>
export interface IconBuildingSkyscraperProps {
  width?: string;
  height?: string;
}

withDefaults(defineProps<IconBuildingSkyscraperProps>(), {
  width: "24px",
  height: "24px",
});
</script>
